import api from './client';
import { Step } from "@/types/assistants";

export type TDataResponseItem = {
    "ID": number,
    "AssistantID": number,
    "Assistant": string,
    "ScenarioID": number,
    "Scenario": string,
    "Name": string,
    "Operator": string,
    "Step": number,
    "Content": string,
    "Context": number,
    "S": Step
}

export const dataApi = {
    getAll: (assistantId: string | number) =>
        api.get<TDataResponseItem[]>('/steps?operator=DATA&assistant_id=' + assistantId)
}
